import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { useAtomDefaults } from "../contexts/atom-defaults-context"
import { Label } from "../components/ui/label"

export function LabelRenderer({ element }: RendererProps) {
  const { resolveSymbol } = useRenderContext()
  const atomDefaults = useAtomDefaults("label")
  const resolvedVariant = (element.variant as string | undefined)
    ?? atomDefaults.defaultVariant
    ?? "default"
  const resolvedSize = (element as { size?: string }).size
    ?? atomDefaults.defaultSize
    ?? "default"
  const text = element.text ? String(resolveSymbol(element.text) ?? "") : undefined
  return (
    <Label
      className={element.className}
      htmlFor={element.name}
      data-testid={`label-${element.id}`}
      data-atom-type="label"
      data-variant={resolvedVariant}
      data-size={resolvedSize}
    >
      {text}
    </Label>
  )
}
